import { render, staticRenderFns } from "./ClientMigrationWindowView.vue?vue&type=template&id=55b89796&scoped=true&"
import script from "./ClientMigrationWindowView.vue?vue&type=script&lang=js&"
export * from "./ClientMigrationWindowView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b89796",
  null
  
)

export default component.exports